import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  BotaoCadastro,
  SelectInput,
  Espaçador,
  CorpoPagina,
  ModalView,
  PesquisaInput,
  TabelaComponente,
  TopicoTexto,
  ModalConfirmacao,
} from '../../../Componentes/index';
import { ModalSubTópico, ModalTópico, ModalTópicoView } from '../../../Componentes/ModalView';
import { FixedInput } from '../../../Componentes/TextInput';
import '../../../Estilos/EstiloBotao.css';
import { apiService } from '../../../Services/ApiService';
import { StoreContexto } from '../../../Contexto/Provider';
import useDebounce from '../../../Hooks/debouceSearch';
import { parseLocation } from '../../../Utils/locationUtil';
import './SensoresLista.css';

function SensoresLista() {
  const navigate = useNavigate();
  const [sensors, setSensors] = useState([]);
  const [sensor, setSensor] = useState({});
  const [totalSensors, setTotalSensors] = useState(0);
  const [search, setSearch] = useState('');
  const debounceSearch = useDebounce(search, 500);
  const [page, setPage] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const [filterType, setFilterType] = useState({ label: 'Geral', value: 'ALL' });

  const { get, del } = apiService();
  const { auth } = useContext(StoreContexto);
  const [menuOptions, setMenuOptions] = useState(['Visualizar']);

  const [modalVisible, setModalVisible] = useState(false);
  const [modalConfirm, setModalConfirm] = useState({
    visible: false,
    message: '',
    operation: '',
    id: '',
  });
  const [modalError, setModalError] = useState({
    visible: false,
    message: '',
  });

  useEffect(() => {
    getSensors();
  }, [page]);

  useEffect(() => {
    if (auth.perfilSalvo === 'OWNER') {
      setMenuOptions(['Visualizar']);
    }
  }, [auth]);

  useEffect(() => {
    getSensors(debounceSearch);
  }, [debounceSearch, filterType]);

  const getSensors = async (currentSearchText = '') => {
    const queryParams = {
      page,
      size: 10,
      search: currentSearchText,
    };

    if (filterType.value !== 'ALL') queryParams.location = filterType.value;

    setIsLoading(true);
    try {
      const data = await get('sensors', queryParams);
      if (data) {
        setSensors(data.result || []);
        setTotalSensors(data.total || 0);
      }
    } catch (error) {
      setModalError({ visible: true, message: 'Erro ao buscar sensores' });
    } finally {
      setIsLoading(false);
    }
  };

  const getSensorById = async (sensorId) => {
    setIsLoading(true);
    try {
      const sensor = await get(`sensors/${sensorId}`);
      setSensor(sensor);
      setModalVisible(true);
    } catch (error) {
      setModalError({ visible: true, message: 'Erro ao buscar sensor' });
    } finally {
      setIsLoading(false);
    }
  };

  const deleteSensor = async (sensorId) => {
    setIsLoading(true);
    try {
      await del(`sensors/${sensorId}`);
      getSensors();
    } catch (error) {
      setModalError({ visible: true, message: 'Erro ao realizar operação' });
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = (text) => {
    setSearch(text.replace(/[^a-zA-Z0-9]/g, ''));
  };

  const handleEditClick = (sensorId) => {
    navigate(`/sensor-form/${sensorId}`);
  };

  const handleMenuItemSelect = (sensorId, menuItem) => {
    switch (menuItem) {
      case 'Visualizar':
        getSensorById(sensorId);
        break;
      case 'Excluir':
        setModalConfirm({
          visible: true,
          message: 'Deseja excluir o sensor?',
          operation: 'Excluir',
          id: sensorId,
        });
        break;
      default:
        break;
    }
  };

  const nextPage = async () => {
    setPage(page + 1);
  };

  const previousPage = async () => {
    setPage(page - 1);
  };

  const getClassification = (location) => {
    return location === 'REFRIGERATOR' ? 'Geladeira' : 'Ambiente';
  };

  const mappedSensors = sensors.map((sensor) => ({
    ...sensor,
    classification: getClassification(sensor.location),
  }));

  return (
    <CorpoPagina loading={isLoading}>
      {modalError.visible && (
        <ModalConfirmacao
          aviso={modalError.message}
          erro={true}
          clicado={() => setModalError({ visible: false, message: '' })}
        />
      )}

      {modalConfirm.visible && (
        <ModalConfirmacao
          aviso={modalConfirm.message}
          confirmar={false}
          clicado={() => {
            deleteSensor(modalConfirm.id);
            setModalConfirm({ visible: false, message: '', operation: '', id: '' });
          }}
          clicadoVolta={() =>
            setModalConfirm({ visible: false, message: '', operation: '', id: '' })
          }
        />
      )}

      {modalVisible && (
        <ModalView height={'100%'} width={'100%'}>
          <ModalTópico titulo="Visualizar Sensor" />
          <div className="form-row">
            <div className="form-column">
              <ModalTópicoView titulo="DADOS GERAIS" top={30} left={20} />
              <ModalSubTópico nome="IDENTIFICAÇÃO" />

              <FixedInput
                titulo="Localização"
                padrao={parseLocation(sensor.location)}
                placeholder="Localização"
                tipo="text"
                largura="90%"
                disabled={true}
              />

              <FixedInput
                titulo="Nome"
                padrao={sensor.name}
                placeholder="Nome"
                tipo="text"
                largura="90%"
                disabled={true}
              />

              <FixedInput
                titulo="ID"
                padrao={sensor.endnode?.endnodeIdentification}
                placeholder="ID"
                tipo="text"
                largura="90%"
                disabled={true}
              />
            </div>
            {sensor.location === 'REFRIGERATOR' && (
              <>
                <div className="form-column">
                  <ModalTópicoView titulo="PARÂMETROS" top={30} left={20} />
                  <ModalSubTópico nome="TEMPERATURA (°C)" />
                  <div
                    style={{
                      display: 'flex',
                      width: '90%',
                      flexDirection: 'row',
                      justifyContent: 'flex-start',
                    }}
                  >
                    <FixedInput
                      titulo="Mínimo"
                      padrao={sensor.minTemperature}
                      placeholder="Mínimo de temperatura"
                      tipo="text"
                      largura="40%"
                      disabled={true}
                    />
                    <Espaçador espaço={30} />
                    <FixedInput
                      titulo="Máximo"
                      padrao={sensor.maxTemperature}
                      placeholder="Máximo de temperatura"
                      tipo="text"
                      largura="40%"
                      disabled={true}
                    />
                  </div>
                  <ModalSubTópico nome="PORTA ABERTA (s)" />
                  <div
                    style={{
                      display: 'flex',
                      width: '90%',
                      flexDirection: 'row',
                      justifyContent: 'flex-start',
                    }}
                  >
                    <FixedInput
                      titulo="Máximo"
                      padrao={sensor.endOfCourseMaxTime}
                      placeholder="Máximo de tempo de porta aberta"
                      tipo="text"
                      largura="40%"
                      disabled={true}
                    />
                  </div>
                </div>
              </>
            )}
          </div>
          <button style={{ margin: 30 }} id="BotaoCadastro" onClick={() => setModalVisible(false)}>
            Fechar
          </button>
        </ModalView>
      )}

      <div className="ContainerGeral">
        <TopicoTexto titulo="Lista de Sensores" />
        <BotaoCadastro
          visivel={auth.perfilSalvo === 'OWNER'}
          nome="Cadastrar"
          clicado={() => navigate('/sensor-form')}
        />
        <div className="sensors-filters">
          {/* <div className='select-filter'>
            <SelectInput
              top={0}
              bottom={16}
              titulo="Filtrar"
              padrao={filterType}
              largura={'100%'}
              itens={[
                { label: 'Geral', value: 'ALL' },
                { label: 'Ambiente', value: 'ENVIRONMENT' },
                { label: 'Geladeira', value: 'REFRIGERATOR' },
              ]}
              clicado={(txt) => {
                setFilterType(txt);
              }}
            />
          </div> */}
          <div className="search-filter">
            <PesquisaInput placeholder="Insira o nome do sensor" onSearch={handleSearch} />
          </div>
        </div>
        <TabelaComponente
          colunas={['SENSOR', 'ENDNODE', 'CLASSIFICAÇÃO', 'AMBIENTE', 'STATUS DE CALIBRAÇÃO']}
          campos={[
            'name',
            'endnode.endnodeIdentification',
            'classification',
            'environment.name',
            'calibrationStatus',
          ]}
          linhas={mappedSensors}
          paginaAtual={page}
          total={totalSensors}
          aviso={!sensors.length ? 'Não há sensor cadastrado' : 'Buscando sensores...'}
          menuOptions={menuOptions}
          onEditClick={handleEditClick}
          onMenuItemSelect={handleMenuItemSelect}
          goToNextPage={() => nextPage()}
          goToPreviousPage={() => previousPage()}
          entity={'sensors'}
          role={auth.perfilSalvo}
        />
      </div>
    </CorpoPagina>
  );
}

export default SensoresLista;
